<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent width="600px">
      <v-card>
        <v-card-title class="text-h5">Adaptar Imagem</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red darken-1" text @click="cancelar">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="cortarImagem">Salvar</v-btn>
        </v-card-actions>
        <cropper
          style="width: 100%; height: 600px"
          class="cropper"
          :src="img"
          :stencil-props="{ aspectRatio: 1 }"
          @change="change"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  name: "EModalCortarImagem",
  components: { Cropper },
  props: {
    dialogProp: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      coordinates: null,
      dialog: this.dialogProp,
    };
  },
  watch: {
    dialogProp(novoValor) {
      this.dialog = novoValor;
    },
  },
  methods: {
    change({ coordinates }) {
      this.coordinates = coordinates;
    },
    async cortarImagem() {
      try {
        if (!this.coordinates) {
          return;
        }

        const data = await this.$services.alunosService.cortarImageAluno(
          this.coordinates,
          this.img
        );

        this.dialog = false;
        this.$emit("atualizar-imagem-aluno", {
          url: data.nameImgAdaptada,
          name: data.singleName,
        });
      } catch (error) {
        this.$handleError(error);
      }
    },
    cancelar() {
      this.dialog = false;
    },
  },
};
</script>
